	export enum NoahSessionPointStatusEnum {
		Regular = 0,
		Nr = 1,
		Unm = 2
	}
